<template>
  <div>
    <my-menu menu-name="junior"></my-menu>

    <div class="banner">
      <img class="bg" src="../assets/images/czheader2.png" />
      <div class="wrapper">
        <div class="switch">
          <router-link to="/teachercz" class="switch-active">教师端</router-link>
          <router-link to="/junior">学生端</router-link>
        </div>
        <div class="inner">
          <!-- <p class="text_weici">初中维词教师版</p>
          <p class="text_slogan">让你的英语教学更精彩</p>
          <div class="product_list">
            <a href="http://bsource.weicistudy.com/pc_download/cz/weicicz_setup.exe" target="_blank" class="product_item">
              <img src="../assets/images/pc.png"/>
              <div class="product_des">
                <p>点击下载</p>
                <p>初中维词教学系统（PC客户端）</p>
              </div>
            </a>
            <a href="http://bsource.weicistudy.com/pc_download/cz/weicicz_setup_mac.dmg" target="_blank" class="product_item">
              <img src="../assets/images/mac.png"/>
              <div class="product_des">
                <p>点击下载</p>
                <p>初中维词教学系统（MAC客户端）</p>
              </div>
            </a>
            <div class="product_item">
              <img src="../assets/images/czqrcode.png"/>
              <div class="product_des">
                <p>扫码下载</p>
                <p>维词教师版APP移动端</p>
              </div>
            </div>
          </div> -->
          <p class="text_weici">维词&bull;初中生</p>
          <p class="text_slogan">自主学习词汇APP</p>
          <img class="qrcode" src="../assets/images/czqrcode.png" />
          <p class="text_download">扫描下载APP</p>
        </div>
        <div class="download">
          <a href="https://itunes.apple.com/cn/app/%E7%BB%B4%E8%AF%8D%E5%88%9D%E4%B8%AD%E7%89%88/id1228082964?mt=8" target="_blank"><img src="../assets/images/ios.png" /></a>
          <div class="line"></div>
          <a href="http://android.myapp.com/myapp/detail.htm?apkName=com.victorstudy.weici.junior" target="_blank"><img src="../assets/images/ad.png" /></a>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="text">
        <p>维词APP初中版</p>
        <p>通过语音、词块，中英文差异句的输入</p>
        <p>有效培养英语学习能力，成为初中词汇学习APP</p>
        <p></p>
      </div>
      <div class="arrow">
        <img src="../assets/images/arrow.png" />
      </div>
      <div class="junior_card">
        <ul>
          <li>
            <img v-lazy="'/static/images/cz1.png'" />
            <div class="junior_label">
              <p>词汇精讲</p>
              <p>标注适合背诵例句、培养词块学习意识</p>
              <p>点拨学生易犯错误、突出英汉表达差异</p>
            </div>
          </li>
          <li>
            <img v-lazy="'/static/images/cz2.png'" />
            <div class="junior_label">
              <p>同步教材</p>
              <p>教材单元同步学习</p>
              <p>备考分级学习，同步课堂学习计划</p>
            </div>
          </li>
          <li>
            <img v-lazy="'/static/images/cz3.png'" />
            <div class="junior_label">
              <p>紧扣教学</p>
              <p>标注单词词频、精选例句、自由订制学习计划</p>
            </div>
          </li>
          <li>
            <img v-lazy="'/static/images/cz4.png'" />
            <div class="junior_label">
              <p>真人离线发声</p>
              <p>真人离线无延迟、精选词块、例句朗读、跟读</p>
            </div>
          </li>
        </ul>
      </div>
<!--      <div class="ex_school">-->
<!--        <img v-lazy="'/static/images/czpic.png'" style="width:100%;" />-->
<!--        <div class="ex_content">-->
<!--          <p>坚持21天培养英语学习好习惯</p>-->
<!--          <p>北京四中、衡水中学等百强名校都在用</p>-->
<!--          <p>A good habit of learning English will be developed if you use it only for 21 days!</p>-->
<!--          <p>Some Top 100 high schools in China such as Beijing No.4 High School and </p>-->
<!--          <p>Hengshui High School of Hebei have already taken the chance.</p>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="stu_list">-->
<!--        <ul>-->
<!--          <li>-->
<!--            <div class="thumb">-->
<!--              <img v-lazy="'/static/images/1.png'" />-->
<!--              <div class="caption">-->
<!--                <p>移动互联网大数据时代，全新的技术和最本质的教学理念将推动中国中学英语教育的改革!</p>-->
<!--                <p style="text-align:right;font-size: 13px">首师大附中</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li>-->
<!--            <div class="thumb">-->
<!--              <img v-lazy="'/static/images/2.png'" />-->
<!--              <div class="caption">-->
<!--                <p>利用维词APP听、读练习，不仅对于口语听力很大的帮助，对于中学生的阅读也有很大的帮助!</p>-->
<!--                <p style="text-align:right;font-size: 13px">重庆一中</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li>-->
<!--            <div class="thumb">-->
<!--              <img v-lazy="'/static/images/3.png'" />-->
<!--              <div class="caption">-->
<!--                <p>维词APP，数字化产品，将会使老师更多机械化的时间被解放出来，用更多的时间做创意英语学习。</p>-->
<!--                <p style="text-align:right;font-size: 13px">郑州外国语学校</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--        </ul>-->
<!--        <div class="clear"></div>-->
<!--      </div>-->
    </section>

    <my-footer></my-footer>
  </div>
</template>

<script>
  import MyFooter from '@/components/Footer'
  import MyMenu from '@/components/Menu'

  export default {
    data () {
      return {}
    },
    components: {
      MyFooter,
      MyMenu
    },
    created () {
    }
  }
</script>



// WEBPACK FOOTER //
// Junior.vue?7d601e3c